import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject, input, model, output } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Banner, BannerName } from '@shared/models/banner.model';
import { BannerService } from '@shared/services';
import { Observable, switchMap } from 'rxjs';

@Component({
  selector: 'lib-banner',
  templateUrl: 'banner.component.html',
  styleUrls: ['banner.component.scss'],
  imports: [AsyncPipe, NgClass],
})
export class BannerComponent {
  public readonly maxWidth = input<string>('970px');
  public readonly maxHeight = input<string>();
  public readonly bannerName = input.required<BannerName | undefined>();
  public readonly withCloseButton = input(false);
  public readonly visible = model(true);
  public readonly content = input<'start' | 'center' | 'end'>();
  public readonly closeBanner = output();

  protected readonly banner$: Observable<Banner | undefined>;

  public constructor() {
    const bannerService = inject(BannerService);

    this.banner$ = toObservable(this.bannerName).pipe(switchMap(bannerName => bannerService.getBannerByName(bannerName)));
  }

  public close() {
    this.visible.set(false);
    this.closeBanner.emit();
  }
}
